import React from "react";
import EmployeeDetails from './Components/EmployeeDetails';

function App() {
  return (
    <div className="App">
      <EmployeeDetails/>
    </div>
    
  );
}

export default App  ;
